/**
 * Every ISO 3166-1 country, by English name. The API sends and takes the alpha-3
 * code (Owner Hub's operating regions use it, e.g. BRA); the alpha-2 code is kept
 * for flags and links. Names are Intl.DisplayNames' English region names.
 */
export type Country = { code3: string; code2: string; name: string };

export const COUNTRIES: Country[] = [
  { code3: 'AFG', code2: 'AF', name: 'Afghanistan' },
  { code3: 'ALA', code2: 'AX', name: 'Åland Islands' },
  { code3: 'ALB', code2: 'AL', name: 'Albania' },
  { code3: 'DZA', code2: 'DZ', name: 'Algeria' },
  { code3: 'ASM', code2: 'AS', name: 'American Samoa' },
  { code3: 'AND', code2: 'AD', name: 'Andorra' },
  { code3: 'AGO', code2: 'AO', name: 'Angola' },
  { code3: 'AIA', code2: 'AI', name: 'Anguilla' },
  { code3: 'ATA', code2: 'AQ', name: 'Antarctica' },
  { code3: 'ATG', code2: 'AG', name: 'Antigua & Barbuda' },
  { code3: 'ARG', code2: 'AR', name: 'Argentina' },
  { code3: 'ARM', code2: 'AM', name: 'Armenia' },
  { code3: 'ABW', code2: 'AW', name: 'Aruba' },
  { code3: 'AUS', code2: 'AU', name: 'Australia' },
  { code3: 'AUT', code2: 'AT', name: 'Austria' },
  { code3: 'AZE', code2: 'AZ', name: 'Azerbaijan' },
  { code3: 'BHS', code2: 'BS', name: 'Bahamas' },
  { code3: 'BHR', code2: 'BH', name: 'Bahrain' },
  { code3: 'BGD', code2: 'BD', name: 'Bangladesh' },
  { code3: 'BRB', code2: 'BB', name: 'Barbados' },
  { code3: 'BLR', code2: 'BY', name: 'Belarus' },
  { code3: 'BEL', code2: 'BE', name: 'Belgium' },
  { code3: 'BLZ', code2: 'BZ', name: 'Belize' },
  { code3: 'BEN', code2: 'BJ', name: 'Benin' },
  { code3: 'BMU', code2: 'BM', name: 'Bermuda' },
  { code3: 'BTN', code2: 'BT', name: 'Bhutan' },
  { code3: 'BOL', code2: 'BO', name: 'Bolivia' },
  { code3: 'BIH', code2: 'BA', name: 'Bosnia & Herzegovina' },
  { code3: 'BWA', code2: 'BW', name: 'Botswana' },
  { code3: 'BVT', code2: 'BV', name: 'Bouvet Island' },
  { code3: 'BRA', code2: 'BR', name: 'Brazil' },
  { code3: 'IOT', code2: 'IO', name: 'British Indian Ocean Territory' },
  { code3: 'VGB', code2: 'VG', name: 'British Virgin Islands' },
  { code3: 'BRN', code2: 'BN', name: 'Brunei' },
  { code3: 'BGR', code2: 'BG', name: 'Bulgaria' },
  { code3: 'BFA', code2: 'BF', name: 'Burkina Faso' },
  { code3: 'BDI', code2: 'BI', name: 'Burundi' },
  { code3: 'KHM', code2: 'KH', name: 'Cambodia' },
  { code3: 'CMR', code2: 'CM', name: 'Cameroon' },
  { code3: 'CAN', code2: 'CA', name: 'Canada' },
  { code3: 'CPV', code2: 'CV', name: 'Cape Verde' },
  { code3: 'BES', code2: 'BQ', name: 'Caribbean Netherlands' },
  { code3: 'CYM', code2: 'KY', name: 'Cayman Islands' },
  { code3: 'CAF', code2: 'CF', name: 'Central African Republic' },
  { code3: 'TCD', code2: 'TD', name: 'Chad' },
  { code3: 'CHL', code2: 'CL', name: 'Chile' },
  { code3: 'CHN', code2: 'CN', name: 'China' },
  { code3: 'CXR', code2: 'CX', name: 'Christmas Island' },
  { code3: 'CCK', code2: 'CC', name: 'Cocos (Keeling) Islands' },
  { code3: 'COL', code2: 'CO', name: 'Colombia' },
  { code3: 'COM', code2: 'KM', name: 'Comoros' },
  { code3: 'COG', code2: 'CG', name: 'Congo - Brazzaville' },
  { code3: 'COD', code2: 'CD', name: 'Congo - Kinshasa' },
  { code3: 'COK', code2: 'CK', name: 'Cook Islands' },
  { code3: 'CRI', code2: 'CR', name: 'Costa Rica' },
  { code3: 'CIV', code2: 'CI', name: 'Côte d’Ivoire' },
  { code3: 'HRV', code2: 'HR', name: 'Croatia' },
  { code3: 'CUB', code2: 'CU', name: 'Cuba' },
  { code3: 'CUW', code2: 'CW', name: 'Curaçao' },
  { code3: 'CYP', code2: 'CY', name: 'Cyprus' },
  { code3: 'CZE', code2: 'CZ', name: 'Czechia' },
  { code3: 'DNK', code2: 'DK', name: 'Denmark' },
  { code3: 'DJI', code2: 'DJ', name: 'Djibouti' },
  { code3: 'DMA', code2: 'DM', name: 'Dominica' },
  { code3: 'DOM', code2: 'DO', name: 'Dominican Republic' },
  { code3: 'ECU', code2: 'EC', name: 'Ecuador' },
  { code3: 'EGY', code2: 'EG', name: 'Egypt' },
  { code3: 'SLV', code2: 'SV', name: 'El Salvador' },
  { code3: 'GNQ', code2: 'GQ', name: 'Equatorial Guinea' },
  { code3: 'ERI', code2: 'ER', name: 'Eritrea' },
  { code3: 'EST', code2: 'EE', name: 'Estonia' },
  { code3: 'SWZ', code2: 'SZ', name: 'Eswatini' },
  { code3: 'ETH', code2: 'ET', name: 'Ethiopia' },
  { code3: 'FLK', code2: 'FK', name: 'Falkland Islands' },
  { code3: 'FRO', code2: 'FO', name: 'Faroe Islands' },
  { code3: 'FJI', code2: 'FJ', name: 'Fiji' },
  { code3: 'FIN', code2: 'FI', name: 'Finland' },
  { code3: 'FRA', code2: 'FR', name: 'France' },
  { code3: 'GUF', code2: 'GF', name: 'French Guiana' },
  { code3: 'PYF', code2: 'PF', name: 'French Polynesia' },
  { code3: 'ATF', code2: 'TF', name: 'French Southern Territories' },
  { code3: 'GAB', code2: 'GA', name: 'Gabon' },
  { code3: 'GMB', code2: 'GM', name: 'Gambia' },
  { code3: 'GEO', code2: 'GE', name: 'Georgia' },
  { code3: 'DEU', code2: 'DE', name: 'Germany' },
  { code3: 'GHA', code2: 'GH', name: 'Ghana' },
  { code3: 'GIB', code2: 'GI', name: 'Gibraltar' },
  { code3: 'GRC', code2: 'GR', name: 'Greece' },
  { code3: 'GRL', code2: 'GL', name: 'Greenland' },
  { code3: 'GRD', code2: 'GD', name: 'Grenada' },
  { code3: 'GLP', code2: 'GP', name: 'Guadeloupe' },
  { code3: 'GUM', code2: 'GU', name: 'Guam' },
  { code3: 'GTM', code2: 'GT', name: 'Guatemala' },
  { code3: 'GGY', code2: 'GG', name: 'Guernsey' },
  { code3: 'GIN', code2: 'GN', name: 'Guinea' },
  { code3: 'GNB', code2: 'GW', name: 'Guinea-Bissau' },
  { code3: 'GUY', code2: 'GY', name: 'Guyana' },
  { code3: 'HTI', code2: 'HT', name: 'Haiti' },
  { code3: 'HMD', code2: 'HM', name: 'Heard & McDonald Islands' },
  { code3: 'HND', code2: 'HN', name: 'Honduras' },
  { code3: 'HKG', code2: 'HK', name: 'Hong Kong SAR China' },
  { code3: 'HUN', code2: 'HU', name: 'Hungary' },
  { code3: 'ISL', code2: 'IS', name: 'Iceland' },
  { code3: 'IND', code2: 'IN', name: 'India' },
  { code3: 'IDN', code2: 'ID', name: 'Indonesia' },
  { code3: 'IRN', code2: 'IR', name: 'Iran' },
  { code3: 'IRQ', code2: 'IQ', name: 'Iraq' },
  { code3: 'IRL', code2: 'IE', name: 'Ireland' },
  { code3: 'IMN', code2: 'IM', name: 'Isle of Man' },
  { code3: 'ISR', code2: 'IL', name: 'Israel' },
  { code3: 'ITA', code2: 'IT', name: 'Italy' },
  { code3: 'JAM', code2: 'JM', name: 'Jamaica' },
  { code3: 'JPN', code2: 'JP', name: 'Japan' },
  { code3: 'JEY', code2: 'JE', name: 'Jersey' },
  { code3: 'JOR', code2: 'JO', name: 'Jordan' },
  { code3: 'KAZ', code2: 'KZ', name: 'Kazakhstan' },
  { code3: 'KEN', code2: 'KE', name: 'Kenya' },
  { code3: 'KIR', code2: 'KI', name: 'Kiribati' },
  { code3: 'KWT', code2: 'KW', name: 'Kuwait' },
  { code3: 'KGZ', code2: 'KG', name: 'Kyrgyzstan' },
  { code3: 'LAO', code2: 'LA', name: 'Laos' },
  { code3: 'LVA', code2: 'LV', name: 'Latvia' },
  { code3: 'LBN', code2: 'LB', name: 'Lebanon' },
  { code3: 'LSO', code2: 'LS', name: 'Lesotho' },
  { code3: 'LBR', code2: 'LR', name: 'Liberia' },
  { code3: 'LBY', code2: 'LY', name: 'Libya' },
  { code3: 'LIE', code2: 'LI', name: 'Liechtenstein' },
  { code3: 'LTU', code2: 'LT', name: 'Lithuania' },
  { code3: 'LUX', code2: 'LU', name: 'Luxembourg' },
  { code3: 'MAC', code2: 'MO', name: 'Macao SAR China' },
  { code3: 'MDG', code2: 'MG', name: 'Madagascar' },
  { code3: 'MWI', code2: 'MW', name: 'Malawi' },
  { code3: 'MYS', code2: 'MY', name: 'Malaysia' },
  { code3: 'MDV', code2: 'MV', name: 'Maldives' },
  { code3: 'MLI', code2: 'ML', name: 'Mali' },
  { code3: 'MLT', code2: 'MT', name: 'Malta' },
  { code3: 'MHL', code2: 'MH', name: 'Marshall Islands' },
  { code3: 'MTQ', code2: 'MQ', name: 'Martinique' },
  { code3: 'MRT', code2: 'MR', name: 'Mauritania' },
  { code3: 'MUS', code2: 'MU', name: 'Mauritius' },
  { code3: 'MYT', code2: 'YT', name: 'Mayotte' },
  { code3: 'MEX', code2: 'MX', name: 'Mexico' },
  { code3: 'FSM', code2: 'FM', name: 'Micronesia' },
  { code3: 'MDA', code2: 'MD', name: 'Moldova' },
  { code3: 'MCO', code2: 'MC', name: 'Monaco' },
  { code3: 'MNG', code2: 'MN', name: 'Mongolia' },
  { code3: 'MNE', code2: 'ME', name: 'Montenegro' },
  { code3: 'MSR', code2: 'MS', name: 'Montserrat' },
  { code3: 'MAR', code2: 'MA', name: 'Morocco' },
  { code3: 'MOZ', code2: 'MZ', name: 'Mozambique' },
  { code3: 'MMR', code2: 'MM', name: 'Myanmar (Burma)' },
  { code3: 'NAM', code2: 'NA', name: 'Namibia' },
  { code3: 'NRU', code2: 'NR', name: 'Nauru' },
  { code3: 'NPL', code2: 'NP', name: 'Nepal' },
  { code3: 'NLD', code2: 'NL', name: 'Netherlands' },
  { code3: 'NCL', code2: 'NC', name: 'New Caledonia' },
  { code3: 'NZL', code2: 'NZ', name: 'New Zealand' },
  { code3: 'NIC', code2: 'NI', name: 'Nicaragua' },
  { code3: 'NER', code2: 'NE', name: 'Niger' },
  { code3: 'NGA', code2: 'NG', name: 'Nigeria' },
  { code3: 'NIU', code2: 'NU', name: 'Niue' },
  { code3: 'NFK', code2: 'NF', name: 'Norfolk Island' },
  { code3: 'PRK', code2: 'KP', name: 'North Korea' },
  { code3: 'MKD', code2: 'MK', name: 'North Macedonia' },
  { code3: 'MNP', code2: 'MP', name: 'Northern Mariana Islands' },
  { code3: 'NOR', code2: 'NO', name: 'Norway' },
  { code3: 'OMN', code2: 'OM', name: 'Oman' },
  { code3: 'PAK', code2: 'PK', name: 'Pakistan' },
  { code3: 'PLW', code2: 'PW', name: 'Palau' },
  { code3: 'PSE', code2: 'PS', name: 'Palestinian Territories' },
  { code3: 'PAN', code2: 'PA', name: 'Panama' },
  { code3: 'PNG', code2: 'PG', name: 'Papua New Guinea' },
  { code3: 'PRY', code2: 'PY', name: 'Paraguay' },
  { code3: 'PER', code2: 'PE', name: 'Peru' },
  { code3: 'PHL', code2: 'PH', name: 'Philippines' },
  { code3: 'PCN', code2: 'PN', name: 'Pitcairn Islands' },
  { code3: 'POL', code2: 'PL', name: 'Poland' },
  { code3: 'PRT', code2: 'PT', name: 'Portugal' },
  { code3: 'PRI', code2: 'PR', name: 'Puerto Rico' },
  { code3: 'QAT', code2: 'QA', name: 'Qatar' },
  { code3: 'REU', code2: 'RE', name: 'Réunion' },
  { code3: 'ROU', code2: 'RO', name: 'Romania' },
  { code3: 'RUS', code2: 'RU', name: 'Russia' },
  { code3: 'RWA', code2: 'RW', name: 'Rwanda' },
  { code3: 'WSM', code2: 'WS', name: 'Samoa' },
  { code3: 'SMR', code2: 'SM', name: 'San Marino' },
  { code3: 'STP', code2: 'ST', name: 'São Tomé & Príncipe' },
  { code3: 'SAU', code2: 'SA', name: 'Saudi Arabia' },
  { code3: 'SEN', code2: 'SN', name: 'Senegal' },
  { code3: 'SRB', code2: 'RS', name: 'Serbia' },
  { code3: 'SYC', code2: 'SC', name: 'Seychelles' },
  { code3: 'SLE', code2: 'SL', name: 'Sierra Leone' },
  { code3: 'SGP', code2: 'SG', name: 'Singapore' },
  { code3: 'SXM', code2: 'SX', name: 'Sint Maarten' },
  { code3: 'SVK', code2: 'SK', name: 'Slovakia' },
  { code3: 'SVN', code2: 'SI', name: 'Slovenia' },
  { code3: 'SLB', code2: 'SB', name: 'Solomon Islands' },
  { code3: 'SOM', code2: 'SO', name: 'Somalia' },
  { code3: 'ZAF', code2: 'ZA', name: 'South Africa' },
  { code3: 'SGS', code2: 'GS', name: 'South Georgia & South Sandwich Islands' },
  { code3: 'KOR', code2: 'KR', name: 'South Korea' },
  { code3: 'SSD', code2: 'SS', name: 'South Sudan' },
  { code3: 'ESP', code2: 'ES', name: 'Spain' },
  { code3: 'LKA', code2: 'LK', name: 'Sri Lanka' },
  { code3: 'BLM', code2: 'BL', name: 'St. Barthélemy' },
  { code3: 'SHN', code2: 'SH', name: 'St. Helena' },
  { code3: 'KNA', code2: 'KN', name: 'St. Kitts & Nevis' },
  { code3: 'LCA', code2: 'LC', name: 'St. Lucia' },
  { code3: 'MAF', code2: 'MF', name: 'St. Martin' },
  { code3: 'SPM', code2: 'PM', name: 'St. Pierre & Miquelon' },
  { code3: 'VCT', code2: 'VC', name: 'St. Vincent & Grenadines' },
  { code3: 'SDN', code2: 'SD', name: 'Sudan' },
  { code3: 'SUR', code2: 'SR', name: 'Suriname' },
  { code3: 'SJM', code2: 'SJ', name: 'Svalbard & Jan Mayen' },
  { code3: 'SWE', code2: 'SE', name: 'Sweden' },
  { code3: 'CHE', code2: 'CH', name: 'Switzerland' },
  { code3: 'SYR', code2: 'SY', name: 'Syria' },
  { code3: 'TWN', code2: 'TW', name: 'Taiwan' },
  { code3: 'TJK', code2: 'TJ', name: 'Tajikistan' },
  { code3: 'TZA', code2: 'TZ', name: 'Tanzania' },
  { code3: 'THA', code2: 'TH', name: 'Thailand' },
  { code3: 'TLS', code2: 'TL', name: 'Timor-Leste' },
  { code3: 'TGO', code2: 'TG', name: 'Togo' },
  { code3: 'TKL', code2: 'TK', name: 'Tokelau' },
  { code3: 'TON', code2: 'TO', name: 'Tonga' },
  { code3: 'TTO', code2: 'TT', name: 'Trinidad & Tobago' },
  { code3: 'TUN', code2: 'TN', name: 'Tunisia' },
  { code3: 'TUR', code2: 'TR', name: 'Türkiye' },
  { code3: 'TKM', code2: 'TM', name: 'Turkmenistan' },
  { code3: 'TCA', code2: 'TC', name: 'Turks & Caicos Islands' },
  { code3: 'TUV', code2: 'TV', name: 'Tuvalu' },
  { code3: 'UMI', code2: 'UM', name: 'U.S. Outlying Islands' },
  { code3: 'VIR', code2: 'VI', name: 'U.S. Virgin Islands' },
  { code3: 'UGA', code2: 'UG', name: 'Uganda' },
  { code3: 'UKR', code2: 'UA', name: 'Ukraine' },
  { code3: 'ARE', code2: 'AE', name: 'United Arab Emirates' },
  { code3: 'GBR', code2: 'GB', name: 'United Kingdom' },
  { code3: 'USA', code2: 'US', name: 'United States' },
  { code3: 'URY', code2: 'UY', name: 'Uruguay' },
  { code3: 'UZB', code2: 'UZ', name: 'Uzbekistan' },
  { code3: 'VUT', code2: 'VU', name: 'Vanuatu' },
  { code3: 'VAT', code2: 'VA', name: 'Vatican City' },
  { code3: 'VEN', code2: 'VE', name: 'Venezuela' },
  { code3: 'VNM', code2: 'VN', name: 'Vietnam' },
  { code3: 'WLF', code2: 'WF', name: 'Wallis & Futuna' },
  { code3: 'ESH', code2: 'EH', name: 'Western Sahara' },
  { code3: 'YEM', code2: 'YE', name: 'Yemen' },
  { code3: 'ZMB', code2: 'ZM', name: 'Zambia' },
  { code3: 'ZWE', code2: 'ZW', name: 'Zimbabwe' },
];

const byCode3 = new Map(COUNTRIES.map((c) => [c.code3, c]));
const byCode2 = new Map(COUNTRIES.map((c) => [c.code2, c]));

/** The country with this alpha-3 code, if it is one. */
export const countryByCode3 = (code: string) => byCode3.get(code);

/** The country with this alpha-2 code, if it is one: some owners' countries come as CO, not COL. */
export const countryByCode2 = (code: string) => byCode2.get(code);

/** Owner Hub's operating regions that are not countries, by name. Mirrors regionNames in backend/pkg/api/countries.go. */
export const REGION_NAMES: Record<string, string> = { EU: 'European Union', INT: 'International' };
